import { Lock } from "lucide-react";

import { cn } from "@/lib/utils";
import type { CapabilityFlag } from "@/types/capabilities";

type LockedFeatureCardProps = {
  title: string;
  description?: string;
  onUpgrade?: () => void;
  variant?: "default" | "inline";
  className?: string;
  children?: React.ReactNode;
  flag?: CapabilityFlag | string;
};

export function LockedFeatureCard({
  title,
  description,
  onUpgrade,
  variant = "default",
  className,
  children,
  flag,
}: LockedFeatureCardProps) {
  const isInline = variant === "inline";
  return (
    <div
      className={cn(
        "rounded-2xl border border-amber-400/40 bg-amber-500/10 text-sm text-primary-foreground dark:text-amber-100",
        isInline ? "p-3" : "p-4",
        className,
      )}
      data-capability-flag={flag ?? undefined}
    >
      <div className="flex items-start gap-3">
        <div className="rounded-full bg-amber-500/20 p-2 text-primary-foreground dark:text-amber-200">
          <Lock className="h-4 w-4" />
        </div>
        <div className="flex-1 space-y-1">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary-foreground dark:text-amber-200">{title}</p>
          {description && <p className="text-xs text-primary-foreground dark:text-amber-100/90">{description}</p>}
          {children}
        </div>
      </div>
      {onUpgrade && (
        <button
          type="button"
          className="mt-3 inline-flex items-center rounded-full border border-amber-300/70 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary-foreground dark:text-amber-100 transition hover:border-amber-100 hover:text-foreground"
          onClick={onUpgrade}
        >
          Upgrade
        </button>
      )}
    </div>
  );
}

export default LockedFeatureCard;
